import { Box, Typography } from "@mui/material";
import localize from "../../../common/localize";
import { getValueInCurrency } from "../../../common/utils";
import { getCurrencyFromSetup } from "../../../common/EntitiesManagement";
import SettlementDetailCard from "./SettlementDetailCard";

export default function EventSettlementDetails({ details }) {
  if (!details || details.length === 0) {
    return (
      <Typography sx={{ fontSize: "0.85rem", color: "#6B7280" }}>
        {localize.no_data}
      </Typography>
    );
  }

  const settlementId = details?.[0]?.settlementId;
  const totalSettled = details.reduce(
    (sum, item) =>
      [0, 1, 3].includes(item?.Status) ? sum + (item?.value ?? 0) : sum,
    0,
  );

  return (
    <Box className="flex flex-col gap-3 w-full">
      <Box className="flex flex-row flex-wrap items-center justify-between gap-2">
        {settlementId ? (
          <Box className="flex flex-row flex-wrap items-center gap-2">
            <Typography sx={{ fontSize: "0.8rem", fontWeight: 600, color: "#374151" }}>
              {`${localize.settlement_detail_title}:`}
            </Typography>
            <a
              href={`/settlement/${settlementId}`}
              target="_blank"
              rel="noopener noreferrer"
              style={{
                color: "#1976d2",
                textDecoration: "underline",
                cursor: "pointer",
                fontSize: "0.85rem",
              }}
            >
              {`${settlementId}`.split("-")[0]}
            </a>
          </Box>
        ) : (
          <span />
        )}
        <Typography className="field_title_text">
          <b>{`${localize.settlement_total_settled_value}: ${getValueInCurrency(
            getCurrencyFromSetup(),
            totalSettled,
          )}`}</b>
        </Typography>
      </Box>

      {details.map((item) => (
        <SettlementDetailCard
          key={item?.id ?? item?.Uuid}
          item={item}
          readOnly
          hideEventCode
        />
      ))}
    </Box>
  );
}
